export default __webpack_public_path__ + "static/media/image-46.5757c023.png";